<script setup>

</script>

<template>
  <div id="main_body">
    <header class="main_header">
      <div class="header-wrapper">
        <div class="inner">
          <img src="@/assets/uploads/contact.jpg" class="attachment-full size-full">
        </div>
      </div>
    </header>

    <div id="primary" class="content-area">
      <main id="content" class="site-content">
        <div class="main_content">
          <div class="container">
            <div class="inner-content">
              <div class="at-above-post-page addthis_tool">&nbsp;</div>
              <div class="vc_row wpb_row vc_row-fluid">
                <div class="wpb_column vc_column_container vc_col-sm-6">
                  <div class="vc_column-inner">
                    <div class="wpb_wrapper">

                      <div class="vc_row wpb_row vc_inner vc_row-fluid">
                        <div class="wpb_column vc_column_container vc_col-sm-3">
                          <div class="vc_column-inner">
                            <div class="wpb_wrapper">
                              <div class="wpb_text_column wpb_content_element ">
                                <div class="wpb_wrapper">
                                  <p><strong>客服服务</strong></p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="wpb_column vc_column_container vc_col-sm-9">
                          <div class="vc_column-inner">
                            <div class="wpb_wrapper">
                              <div class="wpb_text_column wpb_content_element ">
                                <div class="wpb_wrapper">
                                  <p>
                                    <strong>手机:</strong> <a class="phone-number wpb_button_a" href="#">王先生 186 2183 9959  高女士 135 2441 5736</a><br>
                                    <strong>电话:</strong> <a class="phone-number wpb_button_a" href="#">021 6184 6262</a><br>
                                    <strong>邮件:</strong> <a  href="mailto:jingyou@newgreendesign.com">jingyou@newgreendesign.com</a>
                                  </p>

                                  <div>
                                    <img src="@/assets/images/code1.jpg" style="width:140px;" />
                                    <div style="font-size:14px;padding-left:18px;">扫一下联系我们</div>
                                  </div>
                                  <div>&nbsp;</div>
                                  <div>
                                    <img src="@/assets/images/code2.jpg" style="width:140px;" />
                                    <div style="font-size:14px;padding-left:18px;">快速联络报价入口</div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

